import { render, staticRenderFns } from "./modal-order-shipment-details.vue?vue&type=template&id=718d251d&scoped=true"
import script from "./modal-order-shipment-details.vue?vue&type=script&lang=js"
export * from "./modal-order-shipment-details.vue?vue&type=script&lang=js"
import style0 from "./modal-order-shipment-details.vue?vue&type=style&index=0&id=718d251d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718d251d",
  null
  
)

export default component.exports